import { gql, useQuery } from '@apollo/client';
import get from 'lodash.get';
import { PAGE_SIZE } from '~/modules/common/const';

export const GET_PAGE_OF_PROJECT_RATE_TABLE_ROLE_OPTIONS = gql`
  query pageOfProjectRateTableRoleOptions(
    $inTableInput: PageOfProjectRateTableRoleOptionsInput!
    $notInTableInput: PageOfProjectRateTableRoleOptionsInput!
  ) {
    rolesInRateTable: pageOfProjectRateTableRoleOptions(input: $inTableInput) {
      id
      uri
      displayText
    }
    rolesNotInRateTable: pageOfProjectRateTableRoleOptions(
      input: $notInTableInput
    ) {
      id
      uri
      displayText
    }
  }
`;

const useGroupedProjectRateCardRoles = ({ projectId, searchText }) => {
  const { data, loading, refetch } = useQuery(
    GET_PAGE_OF_PROJECT_RATE_TABLE_ROLE_OPTIONS,
    {
      variables: {
        inTableInput: {
          projectId,
          page: 1,
          pageSize: PAGE_SIZE + 1,
          filter: { searchText, inRateTable: true }
        },
        notInTableInput: {
          projectId,
          page: 1,
          pageSize: PAGE_SIZE + 1,
          filter: { searchText, inRateTable: false }
        }
      },
      context: {
        debounceKey: 'project-rate-table-role-options',
        debounceTimeout: 250
      },
      fetchPolicy: 'cache-and-network'
    }
  );

  const rolesInRateTable = get(data, 'rolesInRateTable', []);
  const rolesNotInRateTable = get(data, 'rolesNotInRateTable', []);

  return {
    roleOptions: [
      ...rolesInRateTable.map(r => ({
        ...r,
        isInRateTable: true,
        groupLabelId: 'rateCard.dropdown.projectRateCardRoles'
      })),
      ...rolesNotInRateTable.map(r => ({
        ...r,
        isInRateTable: false,
        groupLabelId: 'rateCard.dropdown.otherRoles'
      }))
    ],
    isLoading: loading,
    hasMore: rolesNotInRateTable.length > PAGE_SIZE,
    refetch
  };
};

export default useGroupedProjectRateCardRoles;
